module.exports = __webpack_public_path__ + "ptc_nakagawa_L1.c974f5c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_L1.jpg
// module id = jKar
// module chunks = 0